import React, { ReactNode } from 'react';
import { ANIMATION_DURATION, SIDEBAR_DIMENSIONS } from './constants';

interface UILogoProps {
  logo: ReactNode;
  /** Shown while collapsed. The brand forbids cropping the lockup down to
   *  its icon, so a collapsed sidebar needs the icon file itself. */
  collapsedLogo?: ReactNode;
  href?: string;
  isCollapsed: boolean;
  className?: string;
  style?: React.CSSProperties;
}

export function UILogo({
  logo,
  collapsedLogo,
  href,
  isCollapsed,
  className,
  style,
}: UILogoProps) {
  const logoContainerStyle: React.CSSProperties = isCollapsed
    ? {
        width: SIDEBAR_DIMENSIONS.LOGO_COLLAPSED_WIDTH,
        marginLeft: SIDEBAR_DIMENSIONS.LOGO_COLLAPSED_MARGIN_LEFT,
        transition: `width ${ANIMATION_DURATION}ms cubic-bezier(0.4, 0, 0.2, 1), margin ${ANIMATION_DURATION}ms cubic-bezier(0.4, 0, 0.2, 1)`,
      }
    : {
        margin: 'auto',
        transition: `margin ${ANIMATION_DURATION}ms cubic-bezier(0.4, 0, 0.2, 1)`,
      };

  const containerStyle: React.CSSProperties = {
    flexShrink: 0,
    display: 'flex',
    alignItems: 'center',
    overflow: 'hidden',
    textDecoration: 'none',
    color: 'inherit',
    ...logoContainerStyle,
    ...style,
  };

  const shown = isCollapsed && collapsedLogo ? collapsedLogo : logo;

  if (href) {
    // Simple anchor tag - same approach as "Back Home" link
    // If href starts with http:// or https://, browser will navigate externally
    // Otherwise, it will be treated as a relative path
    return (
      <a href={href} className={className} style={containerStyle}>
        {shown}
      </a>
    );
  }

  return (
    <div className={className} style={containerStyle}>
      {shown}
    </div>
  );
}
